import { User } from 'src/backoffice-app-code/features/Auth/models/User';
import {
  BrandsRoutes,
  HomePagesRoutes,
  PartnerUsersRoutes,
  SpecificationRootes,
  DistributorTransactionsRootes,
  DistributorsRoutes,
} from '../Routes';
import { ICONS } from './navIcons';

export const getDistributorPartnerAdminNavConfig = (user: User | undefined) => {
  if (!user) return [];
  const distributorPartnerAdminNavConfig = [
    {
      subheader: 'general',
      items: [{ title: 'Home', path: HomePagesRoutes.distributorHomePage, icon: ICONS.dashboard }],
    },
    {
      subheader: 'Transakcije',
      items: [
        {
          title: 'Transakcije',
          path: DistributorTransactionsRootes.index,
          icon: ICONS.invoice,
        },
        {
          title: 'Specifikacije',
          path: SpecificationRootes.index,
          icon: ICONS.banking,
        },
      ],
    },
    {
      subheader: 'Managment',
      items: [
        {
          title: 'Administratori',
          path: PartnerUsersRoutes.buildIndex(user.partnerId),
          icon: ICONS.user,
        },
        {
          title: 'Brendovi',
          path: DistributorsRoutes.brandIndex,
          icon: ICONS.ecommerce,
        },
      ],
    },
  ];

  return distributorPartnerAdminNavConfig;
};
